<template>
  <div class="app_success_page">
    <p class="success_">预约成功！</p>
    <p class="tip_">同样的信息不需要重复预约</p>
    <serviceQrCode :isFengChannel="channelSystem == 4" :userId="$route.query.userId" type="success" />
  </div>
</template>
<style lang="scss" scoped>
.app_success_page {
  background: #F6F7F9;
  width: 100%;
  height: 100vh;
  padding-top: 62px;
  margin: 0 auto;
  .success_ {
    font-size: 22px;
font-family: PingFang SC;
font-weight: 500;
color: #E66765;
line-height: 40px;
// margin-bottom: 18px;
  }
  .tip_ {
    font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #303030;
line-height: 23px;
margin: 19px 0;
  }
}
</style>
<script>
import api from "@/utils/nsaleApi";
import sensorsEvent from '@/utils/sc.js';
import serviceQrCode from './components/serviceQrCode.vue'
export default {
  components: { serviceQrCode },
  data() {
    return {
      productName: '',
      channelSystem: ''
    }
  },
  methods: {
    // jssdk
    fetchJsSdkSign() {
        const url = encodeURIComponent(location.href.split('#')[0])
        // alert('获取签名url ->' + url)
        api.getJsJdkSign({
          url
        }).then(async (data) => {
          const { appId, jssdkReqData } = data.data
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ['hideOptionMenu', 'showOptionMenu']
          }
          const { wxHideMenu } = await this.$wx.wxConfig(options)
          wxHideMenu()
        })
      },
  },
  created() {
    // 埋点
    let sensorsData = sessionStorage.getItem('sensorsData') ? JSON.parse(sessionStorage.getItem('sensorsData')) : {};
    sensorsEvent(sensorsData);
    document.title = this.$route.query.productName
    this.channelSystem = this.$route.query.channelSystem
    this.fetchJsSdkSign();
  }
}
</script>

